module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-ppt-956b4956.svg";